import React from 'react';
import { NavLink } from 'react-router-dom';

// eslint-disable-next-line max-len
export const aftercareMastheadText = 'We opted for private cremation...Dr. Allie went over the options for engraving the urn, clipped a lock of hair from her favorite spot to be scratched and made a paw print impression for me to keep. Those little touches just help to show how much she cares about this work.';

export const aftercareEmbedText = (
	<>
		<p>
			Deciding on the aftercare of your pet’s remains is very personal and a decision that only you can make. There are three options available
			to choose from, which are further explained below:
		</p>
		<p>
			1.) Private cremation
			<br />
			2.) Communal cremation
			<br />
			3.) Home burial
		</p>
		<p>If you choose cremation, our veterinarian will ensure your pet is safely delivered to the crematory.</p>
	</>
);

export const aftercareRichText1 = (
	<>
		<h6>Private Cremation</h6>
		<p>
			With this option, your pet will be privately cremated at a licensed crematory, hand-picked by our team. We choose our crematory based on a
			number of top-quality attributes. The final, and absolutely most important attribute is that our doctors would trust them with their own
			pet. Visit the page of your local Lap of Love veterinarian for more detailed information about the delivery of your pet’s ashes.
		</p>
		<h6>Communal Cremation</h6>
		<p>Your pet will be cremated alongside other beloved pets and their ashes will be scattered together by the crematory.</p>
		<h6>Home Burial</h6>
		<p>
			If you elect to bury your pet at home, make sure to check the local regulations in your area. Our veterinarians do not assist with burial
			preparations. See some tips about home burials
			{' '}
			<NavLink to="/our-services/aftercare/burial" className="inline-link">
				here
			</NavLink>
			.
		</p>
		<h6>Additional Options</h6>
		<p>
			If the above choices don’t fit your family’s needs, you have another option. A traditional burial at a pet cemetery can be a very
			beautiful and elaborate option complete with a ceremony, casket, headstone, and grave plot. Prices typically start at $1,500 but can
			increase depending on the providers in your area.
		</p>
	</>
);

export const aftercareRichText2 = (
	<>
		<p>
			We understand the importance of these last acts of kindness for your pet, so we select our aftercare providers based on our extremely high
			standards of care and veterinary approval. Rest assured that your pet is being cared for both safely and respectfully throughout this
			process.
		</p>
		<p>
			Depending on your location, we partner with fire-based and water-based crematories. While the process for these options is different, both
			are respectful. With either option, your pet’s ashes will be returned to you in an urn, if that’s what you prefer.
		</p>
		<p>There are two options (private and communal) available if you choose to have Lap of Love handle your pet’s remains.</p>
	</>
);
